// extracted by mini-css-extract-plugin
module.exports = {"common":"button__common___SsQ04","typeFill":"button__typeFill___BHcCn","typeEmptyThin":"button__typeEmptyThin___kpxS0","typeEmpty":"button__typeEmpty___YZhQU"};